import { formatCurrency, buildTestIds } from "application";
import { Skeleton } from "components";
import { Price } from "typing";
import {
  Box,
  BoxOptions,
  BoxTitle,
  Container,
  FlagDiscount,
  SubTitle,
  TextHighlight,
  TextHighlightWrapper,
  TextHighlightWrapperRow,
  TextTitle,
  TitleHighlight,
} from "./styles";

interface SelectPricePackageProps {
  PACKAGES_PRODUCT?: Price[];
  packingSelection?: Price;
  measuredUnity?: string;
  setSelectPackage: (packingLevelSelection: Price) => void;
}

const SelectPricePackage = ({
  measuredUnity,
  PACKAGES_PRODUCT = [],
  packingSelection,
  setSelectPackage,
}: SelectPricePackageProps) => {
  return (
    <Container>
      {packingSelection ? (
        <BoxTitle>
          <TextTitle>Embalagem: </TextTitle>
          {packingSelection?.packingQuantity === 1 ? (
            <SubTitle>
              {packingSelection?.packingQuantity}{" "}
              {packingSelection?.packingQuantity === 1
                ? packingSelection?.descriptionPackagingUnitSingular
                : packingSelection?.descriptionPackagingUnitPlural}
            </SubTitle>
          ) : (
            <SubTitle>
              {`${packingSelection?.descriptionPackagingUnitSingular} de ${
                packingSelection?.packingQuantity
              } ${measuredUnity?.toLowerCase()}.`}
            </SubTitle>
          )}
        </BoxTitle>
      ) : (
        <Skeleton count={1} width={115} height={20} />
      )}
      <BoxOptions {...buildTestIds("packaging-options")}>
        {PACKAGES_PRODUCT?.map((item) => (
          <Box
            key={`${item?.unitaryValue}#${item?.unitaryValue}`}
            className={
              item?.packingLevel === packingSelection?.packingLevel
                ? "active"
                : "disabled"
            }
            onClick={() => setSelectPackage(item)}
            {...buildTestIds("select-package-box")}
          >
            {item?.packingQuantity === 1 ? (
              <TitleHighlight>
                {`${item?.packingQuantity} ${
                  item?.packingQuantity === 1
                    ? item?.descriptionPackagingUnitSingular
                    : item?.descriptionPackagingUnitPlural
                }`}
              </TitleHighlight>
            ) : (
              <TitleHighlight>
                {`${item?.descriptionPackagingUnitSingular} de ${
                  item?.packingQuantity
                } ${measuredUnity?.toLowerCase()}.`}
              </TitleHighlight>
            )}
            <TextHighlightWrapper>
              <TextHighlightWrapperRow>
                <TextHighlight>{formatCurrency(item?.salePrice)}</TextHighlight>
                {+item.discountPercentage > 0 &&
                  item?.packingLevel !== packingSelection?.packingLevel && (
                    <FlagDiscount>{item?.discountPercentage}% OFF</FlagDiscount>
                  )}
              </TextHighlightWrapperRow>
              <TextHighlight>
                {formatCurrency(item?.unitaryValue)} / cada
              </TextHighlight>
            </TextHighlightWrapper>
          </Box>
        ))}
      </BoxOptions>
    </Container>
  );
};

export default SelectPricePackage;
